/*
 * Gerber Life application embed helper script
 */

// fixes this issue: https://gist.github.com/iansltx/18caf551baaa60b79206
function checkIfiOSAndFixCookies(domain) {
    if (iOS() && !cookiesWereFixed()) {
        fixCookies();
    }

    function iOS() {
        // http://stackoverflow.com/questions/9038625/detect-if-device-is-ios
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    function cookiesWereFixed(value) {
        var cookiesWereFixedFlagName = "__iOSCookieIssueAlreadyFixed__";
        if (arguments.length !== 0) {
            createCookie(cookiesWereFixedFlagName, value, 30);
            // to prevent infinite loop also use local storage to save the flag
            try {
                window.sessionStorage.setItem(cookiesWereFixedFlagName, true);
            } catch (e) {
                console.log(e.message);
            }
        }
        return !!readCookie(cookiesWereFixedFlagName) || window.sessionStorage.getItem(cookiesWereFixedFlagName);
    }

    function fixCookies() {
        if (cookiesWereFixed(true)) {
            window.location = "https://" + domain + "/gl/view/m/guide_products/embedded_cookies.jsp?url=" + encodeURIComponent(window.location.href);
        }
    }

    // http://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript
    function createCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    // https://stackoverflow.com/questions/5639346/what-is-the-shortest-function-for-reading-a-cookie-by-name-in-javascript
    function readCookie(name) {
        var value = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)');
        return value ? value.pop() : '';
    }
}

/*
 * Setup method to configure a Gerber Life application embedded in an iframe
 * 
 * @param iframeName - name of the iframe where application is embedded
 * @param hostUrl - host url part, ex: username:password@https://integ.glic.io
 * @param params - application parameters to prefill the form
 * @param appUrl - application url part
 * 
 * @returns an object with success() and error() event handler attach methods,
 * and notify() method used to send events to the embedded application
 */
var glEmbeddedApplicationSetup = (function () {
    return function (iframeName, hostUrl, params, appUrl) {
        var glFrameInitialized = false;
        var messageHandlers = {};
        var eventHandlers = {};
        if (!appUrl) {
            console.error('Missing embedded application url');
            return;
        }

        var glFrame = findIFrameByName(iframeName);

        glFrame.onload = function () {
            glFrameInitialized = true;
            _trySendNotifications();
        };

        postToIFrame(hostUrl, appUrl, iframeName, params);

        // handles embedded app resize event
        createAttachHandler('gl-app-resize')(function (event) {
            if (typeof event.height === 'number' && event.height >= 0) {
                glFrame.height = event.height;
            }
        });

        // handles embedded app specific events
        createAttachHandler('gl-app-event')(function (messageEvent) {
            var event = messageEvent.event;
            var eventHandler = eventHandlers[event.type];
            if (eventHandler) {
                eventHandler(event);
            }
        });

        setupMessageListeners(messageHandlers);

        function createAttachHandler(eventName) {
            return function (handler) {
                messageHandlers[eventName] = handler;
                return this;
            };
        }

        var notificationQueue = {};

        function _trySendNotifications() {
            if (glFrameInitialized) {
                for (var eventName in notificationQueue) {
                    try {
                        glFrame.contentWindow['postMessage'](eventName, hostUrl);
                    } catch (e) { console.log("Message Failed: " + e); }
                }
                notificationQueue = {};
            }
        }

        function notifyEmbeddedApp(eventName) {
            notificationQueue[eventName] = true;
            _trySendNotifications();
            return this;
        }

        function onEmbeddedAppEvent(eventType, eventHandler) {
            eventHandlers[eventType] = eventHandler;
            return this;
        }

        return {
            success: createAttachHandler('gl-app-success'),
            error: createAttachHandler('gl-app-error'),
            onAppEvent: onEmbeddedAppEvent,
            notify: notifyEmbeddedApp
        };
    };

    function findIFrameByName(name) {
        var elems = document.getElementsByName(name);
        if (elems[0]) {
            return elems[0];
        } else {
            console.error('iframe not found');
        }
    }

    // load the iframe using POST method
    function postToIFrame(host, actionUrl, iframeName, params) {

        var actionParamsIndex = actionUrl.indexOf('?');
        var actionParamsStr = '';
        if (actionParamsIndex !== -1) {
            actionParamsStr = actionUrl.slice(actionParamsIndex + 1, actionUrl.length);
            actionUrl = actionUrl.slice(0, actionParamsIndex);
        }
        if (actionUrl) {
            actionUrl = host + actionUrl;
            var form = createIFramePostForm(actionUrl, iframeName);
            var actionParams = parseActionParamsStr(actionParamsStr);
            for (var key in params) {
                actionParams[key] = params[key];
            }
            for (var k in actionParams) {
                setPostFormParam(form, k, actionParams[k]);
            }
            form.submit();
            form.remove();
        } else {
            console.error('Invalid iframe form action url');
        }
    }

    function createIFramePostForm(action, iframeName) {
        var form = document.createElement("form");
        form.method = "POST";
        form.action = action;
        form.target = iframeName;
        document.body.appendChild(form);
        return form;
    }

    function parseActionParamsStr(paramsStr) {
        var params = {};
        if (paramsStr) {
            var actionParamsList = paramsStr.split('&');
            for (var i = 0; i < actionParamsList.length; i++) {
                var actionParam = actionParamsList[i];
                actionParam = actionParam.split('=');
                if (actionParam.length > 1) {
                    params[actionParam[0]] = actionParam[1];
                }
            }
        }
        return params;
    }

    function setPostFormParam(form, name, value) {
        var inputElement = document.createElement("input");
        inputElement.name = name;
        inputElement.value = value;
        inputElement.type = 'hidden';
        form.appendChild(inputElement);
    }

    // setup iframe message listeners
    function setupMessageListeners(messageHandlers) {
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var addEventHandler = window[eventMethod];
        var messageEvent = (eventMethod === "attachEvent") ? "onmessage" : "message";

        addEventHandler(messageEvent, function (e) {
            var event = JSON.parse(e.data);
            if (messageHandlers[event.type]) {
                messageHandlers[event.type](event);
            }
        }, false);
    }
})();

export { glEmbeddedApplicationSetup, checkIfiOSAndFixCookies }


// WEBPACK FOOTER //
// ./src/components/Quoters/Forms/gl.js